
import React, { Component, } from 'react';
import { Modal, ModalHeader, ModalBody, Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Collapse } from 'reactstrap';
import PaymentDialogueStatusView from './PaymentDialogueStatusView.js'
import CreditBookDialogue from './creditBook/CreditBookDialogue'

var configurationManager = require('../../../../utils/config/configurationManager.js');
var stringUtil = require('../../../../utils/string/stringUtil.js');
var formatter = require('../../../../utils/formatter/formatter.js');
var dateUtil = require('../../../../utils/dateUtil/dateUtil.js');
var saleCalculator = require('../../../../utils/domain/sales/saleCalculator.js');
var saleCommonUtility = require('../../../../utils/domain/sales/saleCommonUtility.js');
var saleInitializer = require('../../../../utils/domain/sales/saleInitializer.js');
var viewUtil = require('../../../../utils/view/viewUtil.js');
var constants = require('../../../../utils/domain/constants.js');
var printUtil = require('../../../../utils/print/printUtil.js');
var stateManager = require('../../../../utils/state/stateManager.js');
var arraySort = require('array-sort');
var commonUtility = require('../../../../utils/domain/commonUtility.js');
var storefrontUtility = require('../../../../utils/domain/storefrontUtility.js');
var localizationUtils = require('../../../../utils/domain/localizationUtils');
var rmsApiProxyRetry = require('../../../../utils/api/rmsApiProxyRetry.js');
var jobsServer = require('../../../../utils/jobs/jobsServer.js');
var guidUtil = require('../../../../utils/guid/guidUtil.js');
var staffUtility = require('../../../../utils/domain/staff/staffUtility.js');
const translator = require('../../../../utils/translator/translator.js');

class PaymentDialogue extends Component
{

    constructor(props)
    {
        super(props);

        this.renderOutputScreenPanel = this.renderOutputScreenPanel.bind(this);
        this.renderTransactionHistoryPanel = this.renderTransactionHistoryPanel.bind(this);
        this.renderKeyPadPanel = this.renderKeyPadPanel.bind(this);
        this.renderOtherPaymentTypesPanel = this.renderOtherPaymentTypesPanel.bind(this);

        this.onNumberEntered = this.onNumberEntered.bind(this);
        this.onPaymentMethodClick = this.onPaymentMethodClick.bind(this);
        this.onCreditBookPaymentClick = this.onCreditBookPaymentClick.bind(this);
        this.onOverThePhonePaymentClick = this.onOverThePhonePaymentClick.bind(this);
        this.onCashPayment = this.onCashPayment.bind(this);
        this.onCreditCardPayment = this.onCreditCardPayment.bind(this);
        this.onOfflineCreditCardPayment = this.onOfflineCreditCardPayment.bind(this);
        this.onPercentageKeyEntered = this.onPercentageKeyEntered.bind(this);
        this.onFullAmountClick = this.onFullAmountClick.bind(this);
        this.renderCreditBookDialogue = this.renderCreditBookDialogue.bind(this);



        this.state ={};
        this.state.payableAmount = saleCalculator.calculateRemainingPayableAmount(this.props.sale);
        this.state.displayAmount = this.state.payableAmount;
        this.state.paidAmount = this.props.sale.paidAmount;
        if (props.partialPayableAmount != null && props.partialPayableAmount > constants.numericThresholdValue &&
            props.partialPayableAmount < saleCalculator.calculateRemainingPayableAmount(this.props.sale))
        {
            this.state.displayAmount =  props.partialPayableAmount;
            this.state.payableAmount = props.partialPayableAmount;
            this.state.paidAmount = 0;
        }
        this.state.screenAmountNeedsToBeCleared = true;
        this.state.keyPadDisabled = false;
        
        this.state.paymentDisabled = this.state.keyPadDisabled;
        this.state.cashPaymentDisabled = this.state.paymentDisabled;
        this.state.creditCardDisabled = this.state.paymentDisabled;
        this.state.otherPaymentsDisabled = this.state.paymentDisabled;
    
        this.state.paymentModified = false;

        this.resetPaymentServerStatusViewState();
    }

    render()
    {
        this.state.keyPadDisabled = this.state.payableAmount <= constants.numericThresholdValue;
        this.state.paymentDisabled = this.state.keyPadDisabled || this.state.displayAmount <= constants.numericThresholdValue;

        this.state.cashPaymentDisabled = this.state.paymentDisabled;
        this.state.creditCardDisabled = this.state.paymentDisabled || this.state.displayAmount > this.state.payableAmount;
        this.state.otherPaymentsDisabled = this.state.paymentDisabled;
        
        return(<div>
                <Modal isOpen={true} centered animation={false} fade={false} size="lg" style={{maxWidth: '1600px', width: '90%'}}>
                        <ModalBody style={{margin:'-10px'}}>
                                
                                <div style={{height:'80vh'}}>
                                    
                                    <table height="100%" width="100%">
                                        <tr height="10%">
                                            {this.renderOutputScreenPanel()}
                                        </tr>
                                        
                                        <tr height="0%">
                                            <td>
                                                <hr style={{margin:'0px'}}/>
                                            </td>
                                        </tr>
                                        
                                        <tr>
                                            <table width="100%" height="100%">
                                                <tr>
                                                    <td width="50%" height="100%">
                                                        {this.renderTransactionHistoryPanel()}
                                                    </td>
                                                    <td height="100%">
                                                        {this.renderKeyPadPanel()}
                                                    </td>
                                                </tr>
                                            </table>
                                        </tr>
                                    </table>    
        
                                </div>
                                
                        </ModalBody>
                    </Modal>
                    {this.renderPaymentServerStatusView()}
                    {this.renderCreditBookDialogue()}
                </div>);
    }

    renderOutputScreenPanel()
    {
        return (
                    <div style={{background:"white", color:"#484848", height:"100%", width:"100%", padding:'5px'}}>
                        <table width="100%" height="100%">
                            <tr>
                                <td width="40%" valign="top">
                                    <div style={{fontSize:'12px', marginTop:'10px'}}>
                                            <table>
                                                <tr>
                                                    <td>{translator.getLabel("total_Sale")}</td>
                                                    <td><div style={{marginLeft:'5px'}} >{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalNetSalePrice(this.props.sale))}</div> </td>
                                                </tr>
                                                <tr>
                                                    <td>{translator.getLabel("paid")}</td>
                                                    <td><div style={{marginLeft:'5px'}} >{formatter.convertToCurrencyFormat(this.state.paidAmount)}</div> </td>
                                                </tr>
                                                <tr>
                                                    <td>{translator.getLabel("outstanding")}</td>
                                                    <td><div style={{marginLeft:'5px'}} >{formatter.convertToCurrencyFormat(this.state.payableAmount)}</div> </td>
                                                </tr>
                                            </table>
                                        </div>
                                </td>
                                <td width="60%">
                                    <div align="right" verticalAlign="middle" style={{color:"#484848", fontSize:'6vh'}}>
                                        {formatter.convertToCurrencyFormat(this.state.displayAmount)}
                                    </div>
                                </td>
                            </tr>
                        </table>    
                    </div>

                )
    }

    renderTransactionHistoryPanel = ()=>
    {

        var receiptLines = arraySort(this.props.sale.receiptLines, "dateTime")

        var components = [];
        receiptLines.forEach(receiptLine =>
        {
            components.push(<tr>
                                <table width="100%">
                                    <tr>
                                        <td>
                                            <span><strong>{receiptLine.type}  /  {formatter.convertToCurrencyFormat(receiptLine.amount)} / {dateUtil.convertToLocalStandard(receiptLine.dateTime)}</strong></span>
                                        </td>
                                    </tr>
                                    <tr>
                                    <td style={{wordBreak:'break-all'}}>
                                            {receiptLine.line}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <hr style={{margin:'0px', padding:'0px', marginBottom:'5px'}}/>
                                        </td>
                                    </tr>
                                </table>
                            </tr>)
        });


        return (<div style={{height:'99%', width:'100%', padding:'5px', marginTop:'2px', background:'#D3D3D3', fontSize:'12px', overflowY:'auto', borderRadius: '10px'}}>
                    <table width="100%">
                        {components}
                    </table>
                </div>)
    }

    renderKeyPadPanel = () =>
    {
        var currencyDenominations = localizationUtils.getCurrencyDenominations();
        
        return(
            <table width="100%" height="100%" style={{borderCollapse: 'separate', borderSpacing: '4px'}}>  


                <tr >
                    
                        <td width="25%">
                            {this.renderOtherPaymentTypesPanel()}
                        </td>
                        <td width="25%">
                            <Button color="primary" disabled={this.state.cashPaymentDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={this.onCashPayment}>{translator.getLabel("cash")}</Button>
                        </td>
                        <td width="25%">
                            <Button color="success" disabled={this.state.creditCardDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={this.onCreditCardPayment}>{translator.getLabel("credit")}</Button>
                        </td>
                        <td width="25%">
                            <Button color="danger" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.props.onClose(this.state.paymentModified)}}>{translator.getLabel("close")}</Button>
                        </td>
                    
                </tr>
                
                
                    
                    
                        <tr>
                            <td width="25%">
                                <Button color='success' disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem', whiteSpace: 'nowrap'}} onClick={()=>{this.onFullAmountClick()}}>{translator.getLabel("full_amount")}</Button>
                            </td>
                            <td width="25%">
                                <Button  disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#1226bd'}} onClick={()=>{this.onPercentageKeyEntered(0.75)}}>75%</Button>
                            </td>
                            <td width="25%">
                                <Button  disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#253bea'}} onClick={()=>{this.onPercentageKeyEntered(0.50)}}>50%</Button>
                            </td>
                            <td width="25%">
                                <Button  disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#5f6ff0'}} onClick={()=>{this.onPercentageKeyEntered(0.25)}}>25%</Button>
                            </td>
                        </tr>

                        <tr>
                            <td >
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(7)}} className='payment-number-button-style'>7</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(8)}} className='payment-number-button-style'>8</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(9)}} className='payment-number-button-style'>9</Button>
                            </td>
                            <td>
                                <Button disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#33658A'}} onClick={()=>{this.onNumberEntered(currencyDenominations[0] * 100)}}>{formatter.convertToCurrencyFormat(currencyDenominations[0])}</Button>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(4)}} className='payment-number-button-style'>4</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(5)}} className='payment-number-button-style'>5</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(6)}} className='payment-number-button-style'>6</Button>
                            </td>
                            <td>
                                <Button  disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#86BBD8'}} onClick={()=>{this.onNumberEntered(currencyDenominations[1] * 100)}}>{formatter.convertToCurrencyFormat(currencyDenominations[1])}</Button>
                            </td>
                        </tr>
                        
                        <tr>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(1)}} className='payment-number-button-style'>1</Button>
                            </td>
                            <td>
                            <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(2)}} className='payment-number-button-style'>2</Button>
                            </td>
                            <td>
                            <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(3)}} className='payment-number-button-style'>3</Button>
                            </td>
                            <td>
                                <Button  disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#F6AE2D'}} onClick={()=>{this.onNumberEntered(currencyDenominations[2] * 100)}}>{formatter.convertToCurrencyFormat(currencyDenominations[2])}</Button>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(-1)}} className='payment-number-button-style'>◄</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(0)}} className='payment-number-button-style'>0</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(-2)}} className='payment-number-button-style'>00</Button>
                            </td>
                            <td>
                                <Button  disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#F26419'}} onClick={()=>{this.onNumberEntered(currencyDenominations[3] * 100)}}>{formatter.convertToCurrencyFormat(currencyDenominations[3])}</Button>
                            </td>
                        </tr>

                   
            </table>
        )
    }

    renderOtherPaymentTypesPanel()
    {
        var paymentTypes = stateManager.getStore().getState().paymentTypes;
        if (paymentTypes == null)
            paymentTypes = [];

        paymentTypes = paymentTypes.filter(p => stringUtil.isStringNullOrEmpty(p.expiryDate) || dateUtil.isSameOrAfter(p.expiryDate, dateUtil.getToday()));
        paymentTypes.push(this.createCreditBookPaymentType())

        if(saleCommonUtility.canSaleBePaidOverThePhone(this.props.sale))
        {
            paymentTypes.push(this.createOverPhonePaymentType())
        }

        if (paymentTypes.length <= 0)
        {
            return (<ButtonDropdown disabled={true} color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} isOpen={this.state.dropdownOpen} toggle={()=>{
                                                                                                                                                                            this.state.dropdownOpen = !this.state.dropdownOpen;
                                                                                                                                                                            this.setState({})
                                                                                                                                                                        }}>
                        <DropdownToggle disabled={true} color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} caret>
                            {translator.getLabel("others")}
                        </DropdownToggle>

                    </ButtonDropdown>);
        }

        var buttonComponents = [];

        paymentTypes.forEach(paymentType =>
        {
            var isDisabled = this.state.otherPaymentsDisabled;
            
            let color = "MediumSeaGreen";
            if (paymentType.type == constants.PaymentMethodCreditBook)
                color = "DodgerBlue"

            buttonComponents.push(<DropdownItem>
                                        <Button disabled={isDisabled} style={{background: isDisabled ? "LightGray" : color, minWidth:'300px', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onPaymentMethodClick(paymentType)}}>{paymentType.name}</Button>
                                    </DropdownItem>) 
        });

        return(<ButtonDropdown disabled={this.state.keyPadDisabled} color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} isOpen={this.state.dropdownOpen} toggle={()=>{
                                                                                                                                                        this.state.dropdownOpen = !this.state.dropdownOpen;
                                                                                                                                                        this.setState({})
                                                                                                                                                    }}>
                <DropdownToggle disabled={this.state.keyPadDisabled} color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} caret>
                {translator.getLabel("others")}
                </DropdownToggle>
                <DropdownMenu>
                    {buttonComponents}
                </DropdownMenu>
                </ButtonDropdown>)
    }

    createCreditBookPaymentType()
    {
        var creditBookPaymentType = {};
        creditBookPaymentType.id = constants.PaymentMethodCreditBook;
        creditBookPaymentType.franchisorId = commonUtility.getFranchisor().id;
        creditBookPaymentType.code = constants.PaymentMethodCreditBook;
        creditBookPaymentType.name = "Credit Book";
        creditBookPaymentType.description = constants.PaymentMethodCreditBook;
        creditBookPaymentType.type = constants.PaymentMethodCreditBook;
        creditBookPaymentType.maxAmount = Number.MAX_SAFE_INTEGER;
        creditBookPaymentType.expiryDate = null;
        creditBookPaymentType.openCashDrawer = false;
        creditBookPaymentType.notes = "";

        return creditBookPaymentType;
    }

    createOverPhonePaymentType()
    {
        var paymentType = {};
        paymentType.id = constants.PaymentMethodOverPhone;
        paymentType.franchisorId = commonUtility.getFranchisor().id;
        paymentType.code = constants.PaymentMethodOverPhone;
        paymentType.name = "Over Phone Payment";
        paymentType.description = constants.PaymentMethodOverPhone;
        paymentType.type = constants.PaymentMethodOverPhone;
        paymentType.maxAmount = Number.MAX_SAFE_INTEGER;
        paymentType.expiryDate = null;
        paymentType.openCashDrawer = false;
        paymentType.notes = "";

        return paymentType;
    }

    onNumberEntered = (number) =>
    {
        var currencyDenominations = localizationUtils.getCurrencyDenominations();   
        if (this.state.screenAmountNeedsToBeCleared)
        {
            this.state.screenAmountNeedsToBeCleared = false;
            this.state.displayAmount = 0;
        }

        if ( (number == currencyDenominations[0] * 100) || (number == currencyDenominations[1] * 100) || 
             (number == currencyDenominations[2] * 100) || (number == currencyDenominations[3] * 100))
        {
            this.state.displayAmount = 0;
            this.state.screenAmountNeedsToBeCleared = true;
        }

        if (number >= 0)
        {
            this.state.displayAmount = formatter.roundUp(this.state.displayAmount * 10 + number / 100, 2);
        }

        if (number == -1)
        {
            this.state.displayAmount = formatter.roundUp(Math.round(100 * this.state.displayAmount/10) / 100, 2);
        }

        if (number == -2)
        {
            this.state.displayAmount = formatter.roundUp(this.state.displayAmount * 100, 2);
        }


        this.setState({});
    }

    onFullAmountClick()
    {
        this.state.displayAmount = this.state.payableAmount;
        this.state.screenAmountNeedsToBeCleared = true;
        this.setState({});
    }

    onPercentageKeyEntered(percentage)
    {
        var currentRemainingAmount = this.state.payableAmount;
        var percentageAmount = formatter.roundUp(currentRemainingAmount * percentage, 2);
        var remainingAmountAfterPercentage = formatter.roundUp(currentRemainingAmount - percentageAmount, 2);

        if (percentageAmount < 0.25 || remainingAmountAfterPercentage < 0.25)
            return;

        this.state.displayAmount = percentageAmount;
        this.state.screenAmountNeedsToBeCleared = true;
        this.setState({});
    }

    async onPaymentMethodClick(paymentType)
    {
        if (paymentType.type == constants.PaymentMethodCreditBook)
            return this.onCreditBookPaymentClick();

        if (paymentType.type == constants.PaymentMethodOverPhone)
            return this.onOverThePhonePaymentClick();

        var actualPaidAmount = this.state.displayAmount;
        var currentOutstandingAmount = this.state.payableAmount;
        if (actualPaidAmount > currentOutstandingAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("you_cannot_charge_more_than_outstanding_amount_of")} '${formatter.convertToCurrencyFormat(currentOutstandingAmount)}`)
            return;
        }

        if (actualPaidAmount > paymentType.maxAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("you_cannot_charge_more_than_amount_of")} '${formatter.convertToCurrencyFormat(paymentType.maxAmount)} ${translator.getLabel("using_type")} '${paymentType.code}'`)
            return;
        }

        var existingLine = this.props.sale.receiptLines.find (r =>
            {
                var line = JSON.parse(r.line);
                return line.mode == paymentType.code
            });

        if (existingLine != null)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("you_cannot_use_payment_method")} '${paymentType.code}' ${translator.getLabel("multiple_times")}`)
            return;
        }

        this.props.sale.paidAmount = this.props.sale.paidAmount + actualPaidAmount;
        this.state.paidAmount = this.state.paidAmount + actualPaidAmount;
        this.state.payableAmount = this.state.payableAmount - actualPaidAmount;

        var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeCharge, actualPaidAmount, paymentType.code);
        this.props.sale.receiptLines.push(receiptLine);

        this.props.sale.paymentMethod = paymentType.code;

        var nonPaymentTypeReceiptLine = this.props.sale.receiptLines.find (r =>
            {
                var line = JSON.parse(r.line);
                return line.mode != paymentType.code
            });


        if (nonPaymentTypeReceiptLine != null)
        {
            this.props.sale.paymentMethod = constants.PaymentMethodMix;
        }

        this.state.displayAmount = 0.0;
        this.state.screenAmountNeedsToBeCleared = true;
        this.state.paymentModified = true;
        
        this.setState({});
        
        if (this.state.payableAmount <= constants.numericThresholdValue)
        {
            await this.props.onPaymentCompletion();
            this.props.onClose(this.state.paymentModified);
        }

        if (paymentType.openCashDrawer)
            printUtil.openCashDrawer();
    }

    onCreditBookPaymentClick()
    {
        var actualPaidAmount = this.state.displayAmount;
        var currentOutstandingAmount = this.state.payableAmount;
        if (actualPaidAmount > currentOutstandingAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("you_cannot_charge_more_than_outstanding_amount_of")} '${formatter.convertToCurrencyFormat(currentOutstandingAmount)}`)
            return;
        }

        var existingLine = this.props.sale.receiptLines.find (r => r.paymentMethod == constants.PaymentMethodCreditBook);

        if (existingLine != null)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("you_cannot_use_payment_method")} '${constants.PaymentMethodCreditBook}' ${translator.getLabel("multiple_times")}`)
            return;
        }


        this.state.showCreditBookDialogue = true;
        this.setState({});
    }

    onOverThePhonePaymentClick()
    {
        this.props.sale.saleType = constants.SaleTypeHold;
        this.props.sale.holdReasonCode = constants.holdReasonCode.paymentByPhone;

        const webAppConfiguration = storefrontUtility.getPayOverPhoneWebConfiguration(this.props.sale.storefrontId);
        
        let baseUrl = configurationManager.getConfig().appUrlWebOrdering;
        if (!stringUtil.isStringNullOrEmpty(webAppConfiguration.customUrl))
            baseUrl = webAppConfiguration.customUrl;
        
        const dispatchInfo = JSON.parse(this.props.sale.dispatchInfo);

        const orgData = stateManager.getStore().getState().orgData;

        const linkData = {
            franchisorId: orgData.franchisorId,
            franchiseeId: orgData.franchiseeId,
            propertyId: orgData.propertyId,
            storefrontId: this.props.sale.storefrontId,
            applicationId: webAppConfiguration.applicationId,
            saleId: this.props.sale.id,
            orderNumber: this.props.sale.number,
            baseUrl,
            title: webAppConfiguration.title,
            dispatchInfo,
            replyToEmailAddress: webAppConfiguration.emailReplyToAddress
        }

        jobsServer.addJob(guidUtil.generateGuid(), "PaymentLink.Saving", 
        async () =>
        {
            var resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentOverPhone`;
            await rmsApiProxyRetry.post(resource, linkData)
            return true;
        }, false, ()=>
        {
            viewUtil.showCriticalAlert(`${translator.getLabel("failed_sending_pay_by_phone_message_with_order_number")} ${this.props.sale.number}.`);
        });

        viewUtil.showSuccessAlert(translator.getLabel("sms_is_sent_to_customer_with_the_payment_link"));
        this.state.paymentModified = true;
        this.props.onClose(this.state.paymentModified);
    }

    onCashPayment = async () =>
    {
        var previousOutstandingAmount = this.state.payableAmount;
        var actualPaidAmount = this.state.displayAmount;
       
        if (actualPaidAmount > previousOutstandingAmount)
            actualPaidAmount = previousOutstandingAmount;
        
        this.props.sale.paidAmount = this.props.sale.paidAmount + actualPaidAmount;
        this.state.paidAmount = this.state.paidAmount + actualPaidAmount;
        this.state.payableAmount = this.state.payableAmount - actualPaidAmount;
        
        
        var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeCharge, actualPaidAmount, constants.PaymentMethodCash);

        var line = JSON.parse(receiptLine.line);
        line.cashNotePresented = formatter.convertToCurrencyFormat(this.state.displayAmount );
        line.cashNoteChange = this.state.displayAmount > previousOutstandingAmount ?  formatter.convertToCurrencyFormat(this.state.displayAmount - previousOutstandingAmount) : formatter.convertToCurrencyFormat(0.0);
        receiptLine.line = JSON.stringify(line);
        this.props.sale.receiptLines.push(receiptLine);

        this.props.sale.paymentMethod = constants.PaymentMethodCash;

        var nonCashReceiptLine = this.props.sale.receiptLines.find (r =>
            {
                var line = JSON.parse(r.line);
                return line.mode != constants.PaymentMethodCash
            });

        

        if (nonCashReceiptLine != null)
        {
            this.props.sale.paymentMethod = constants.PaymentMethodMix;
        }

        if (this.state.displayAmount > previousOutstandingAmount)
            this.state.displayAmount = previousOutstandingAmount - this.state.displayAmount;
        else
            this.state.displayAmount = 0.0;

        this.state.paymentModified = true;
        this.state.screenAmountNeedsToBeCleared = true;
        
        this.setState({});
        
        if (this.state.payableAmount <= constants.numericThresholdValue)
        {
            await this.props.onPaymentCompletion();
            if (Math.abs(this.state.displayAmount) <= constants.numericThresholdValue)
                this.props.onClose(this.state.paymentModified);
        }

        const storefrontOperatingConfiguration = storefrontUtility.getCurrentStorefront().operatingConfiguration || {};
        const openCashDrawerPaymentMethods = storefrontOperatingConfiguration.openCashDrawerPaymentMethods || [];
        if (openCashDrawerPaymentMethods.includes(constants.PaymentMethodCash))
            printUtil.openCashDrawer();
        
    }


    onCreditCardPayment = async () =>
    {
        var currentOutstandingAmount = this.state.payableAmount;
        if (this.state.displayAmount > currentOutstandingAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("you_cannot_charge_more_than_outstanding_amount_of")}'${formatter.convertToCurrencyFormat(currentOutstandingAmount)}`)
            return;
        }

        var creditCardTerminal = stateManager.getStore().getState().creditCardTerminal;

        if (creditCardTerminal == null || stringUtil.isStringNullOrEmpty(creditCardTerminal.provider))
        {
            viewUtil.showErrorAlert(translator.getLabel("credit_card_provider_settings_are_not_configured_for_this_terminal"))
            return;
        }

        if (stringUtil.areStringSame(creditCardTerminal.provider, "Offline"))
        {
            this.onOfflineCreditCardPayment();
            return;
        }
        
        var cardDriver = creditCardTerminal.underlyingDriver;

        if (cardDriver == null)
        {
            viewUtil.showErrorAlert(translator.getLabel("credit_card_provider_settings_are_not_configured_for_this_terminal"))
            return;
        }

        this.state.paymentServerStatusMessage = translator.getLabel("please_wait");
        this.state.paymentServerDisplayType = 'status';
        cardDriver.chargeAmount(this.props.sale.id, this.state.displayAmount, 
        (notificationMessage) =>
        {
            //On Status Message
            this.state.paymentServerDisplayType = 'status';
            this.state.paymentServerStatusMessage = notificationMessage;
            this.setState({});
        }, 
        (errorMessage) =>
        {
            //On Error Message
            this.state.paymentServerDisplayType = 'error';
            this.state.paymentServerErrorMessage = errorMessage;
            this.setState({});
        }, 
        (requestId, receiptLines)=>
        {
            //On Signature Verification
            printUtil.printCardSignatureVerification(receiptLines);
            this.state.paymentServerVerificationRequestId = requestId;
            this.state.paymentServerDisplayType = 'signature_verification';
            this.setState({});
        },
        ()=>
        {
            //On Signature Verification Timeout
            this.state.paymentServerDisplayType = 'status';
            this.setState({});
        },
        (result) =>
        {
            //On Success

            const tipAmount = (result.tipAmount || 0.0) * 1;

            var line = {};
            line.transactionType = result.transactionType;
            line.cardSchemeName = result.cardSchemeName;
            line.dateOfExpiry = result.dateOfExpiry;
            line.primaryAccountNumber = result.primaryAccountNumber;
            line.cardholderVerificationMethod = result.cardholderVerificationMethod;
            line.paymentMethod = result.paymentMethod;
            line.tpi = result.tpi;
            line.transactionTime = result.transactionTime;
            line.tipAmount = tipAmount;
            line.amountTotal = result.amountTotal;
            line.feeAmount = result.feeAmount || 0;
            line.transactionResult = result.transactionResult;
            line.transactionId = result.transactionId;
            line.authCode = result.authCode;
            line.driver = result.driver;
            line.mode = constants.PaymentMethodCredit;
            line.chargeId = result.chargeId;
            var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeCharge, this.state.displayAmount + tipAmount, constants.PaymentMethodCredit);
            receiptLine.line = JSON.stringify(line);
            this.props.sale.receiptLines.push(receiptLine);

            this.props.sale.paymentMethod = constants.PaymentMethodCredit
            var nonCashReceiptLine = this.props.sale.receiptLines.find (r =>
                {
                    var line = JSON.parse(r.line);
                    return line.mode != constants.PaymentMethodCredit
                });
            if (nonCashReceiptLine != null)
            {
                this.props.sale.paymentMethod = constants.PaymentMethodMix;
            }


            if(tipAmount > constants.numericThresholdValue)
            {
                const charge = {};
                charge.type = constants.ChargesTypes.Tip;
                charge.amount = tipAmount;
                charge.vat = 0;
                charge.notes = "";
                this.props.sale.charges.push(charge)
            }
        
            this.state.paymentModified = true;
            this.props.sale.paidAmount = this.props.sale.paidAmount + this.state.displayAmount + tipAmount;
            this.state.paidAmount = this.state.paidAmount + this.state.displayAmount + tipAmount;
            this.state.payableAmount = this.state.payableAmount - this.state.displayAmount;
           

            const storefrontOperatingConfiguration = storefrontUtility.getCurrentStorefront().operatingConfiguration || {};
            const openCashDrawerPaymentMethods = storefrontOperatingConfiguration.openCashDrawerPaymentMethods || [];
            if (openCashDrawerPaymentMethods.includes(constants.PaymentMethodCredit))
                printUtil.openCashDrawer();

            this.state.displayAmount = 0.0;
            this.state.screenAmountNeedsToBeCleared = true;
            this.state.paymentServerDisplayType = 'success';
            
            this.setState({});
        },
        () =>
        {
            this.state.paymentServerDisplayType = 'decline';
            this.setState({});
        });

        this.setState({});
    }

    onOfflineCreditCardPayment = async ()=>
    {
        var actualPaidAmount = this.state.displayAmount;

        var line = {};
        line.transactionType = "Offline Credit Payment"
        line.mode = constants.PaymentMethodCredit;
        var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeCharge, actualPaidAmount, constants.PaymentMethodCredit);
        receiptLine.line = JSON.stringify(line);
        this.props.sale.receiptLines.push(receiptLine);

        this.props.sale.paymentMethod = constants.PaymentMethodCredit
        var nonCashReceiptLine = this.props.sale.receiptLines.find (r =>
            {
                var line = JSON.parse(r.line);
                return line.mode != constants.PaymentMethodCredit
            });
        if (nonCashReceiptLine != null)
        {
            this.props.sale.paymentMethod = constants.PaymentMethodMix;
        }
    
        this.state.paymentModified = true;
        this.props.sale.paidAmount = this.props.sale.paidAmount + actualPaidAmount;
        this.state.paidAmount = this.state.paidAmount + actualPaidAmount;
        this.state.payableAmount = this.state.payableAmount - actualPaidAmount;
       
        this.state.displayAmount = 0.0;
        this.state.screenAmountNeedsToBeCleared = true;

        this.setState({});

        if (this.state.payableAmount <= constants.numericThresholdValue)
        {
            await this.props.onPaymentCompletion();
            this.props.onClose(this.state.paymentModified)
        }

        const storefrontOperatingConfiguration = storefrontUtility.getCurrentStorefront().operatingConfiguration || {};
        const openCashDrawerPaymentMethods = storefrontOperatingConfiguration.openCashDrawerPaymentMethods || [];
        if (openCashDrawerPaymentMethods.includes(constants.PaymentMethodCredit))
            printUtil.openCashDrawer();
    }

    renderPaymentServerStatusView  = () =>
    {
        if (this.state.paymentServerDisplayType == null)
            return null;

        var creditCardTerminal = stateManager.getStore().getState().creditCardTerminal;
        var cardDriver = creditCardTerminal.underlyingDriver;

        var onCancelTransaction = null;
        if (cardDriver != null && cardDriver.cancelCurrentTransaction != null)
        {
            onCancelTransaction = ()=>
            {
                cardDriver.cancelCurrentTransaction();
            };
        }

        return <PaymentDialogueStatusView displayType={this.state.paymentServerDisplayType} 
                                        statusMessage={this.state.paymentServerStatusMessage}
                                        errorMessage={this.state.paymentServerErrorMessage}
                                        onErrorClose={this.onPaymentServerStatusViewErrorClose}
                                        onSuccessClose={this.onPaymentServerStatusViewSuccessClose}
                                        onDeclineClose={this.onPaymentServerStatusViewDeclineClose}
                                        onCardVerified={this.onCardVerified}
                                        onCardNotVerified={this.onCardNotVerified}
                                        onCancelTransaction={onCancelTransaction}></PaymentDialogueStatusView>
    }

    onPaymentServerStatusViewErrorClose = ()=>
    {
        this.resetPaymentServerStatusViewState();
        this.setState({});
    }

    onPaymentServerStatusViewSuccessClose = async ()=>
    {
        this.resetPaymentServerStatusViewState();
        this.setState({});

        if (this.state.payableAmount <= constants.numericThresholdValue)
        {
            await this.props.onPaymentCompletion();
            this.props.onClose(this.state.paymentModified)
        }

    }

    onPaymentServerStatusViewDeclineClose = ()=>
    {
        this.resetPaymentServerStatusViewState();
        this.setState({});
    }

    onCardVerified = () =>
    {
        var creditCardTerminal = stateManager.getStore().getState().creditCardTerminal;
        var cardDriver = creditCardTerminal.underlyingDriver;
        cardDriver.verifyCardSignature(this.state.paymentServerVerificationRequestId, true);

        this.state.signatureVerified = true;
        this.state.paymentServerDisplayType = 'status';
        this.setState({});
    }

    onCardNotVerified = () =>
    {
        var creditCardTerminal = stateManager.getStore().getState().creditCardTerminal;
        var cardDriver = creditCardTerminal.underlyingDriver;
        cardDriver.verifyCardSignature(this.state.paymentServerVerificationRequestId, false);

        this.state.paymentServerDisplayType = 'status';
        this.setState({});
    }

    resetPaymentServerStatusViewState = ()=>
    {
        this.state.paymentServerDisplayType = null;
        this.state.paymentServerStatusMessage = "";
        this.state.paymentServerErrorMessage = "";
        this.state.paymentServerVerificationRequestId = null;
    }


    renderCreditBookDialogue()
    {
        if (!this.state.showCreditBookDialogue)
            return;

        return <CreditBookDialogue transactionAmount={this.state.displayAmount} transactionReference={this.props.sale.number}
                                   onClose={()=>
                                            {
                                                this.state.showCreditBookDialogue = false;
                                                this.setState({});
                                            }} 
                                    onCompletion={async (creditBook, creditAccount, result)=>
                                    {
                                        var creditBookDetails = `(${creditBook.name} / ${creditAccount.name})`;

                                        var line = {};
                                        line.creditBookId = creditBook.id;
                                        line.creditAccountId = creditAccount.id;
                                        line.creditBookDetails = creditBookDetails;
                                        line.mode = constants.PaymentMethodCreditBook;
                                        line.reference = result.reference;
                                        var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeCharge, this.state.displayAmount, constants.PaymentMethodCreditBook);
                                        receiptLine.line = JSON.stringify(line);
                                        this.props.sale.receiptLines.push(receiptLine);

                                        this.props.sale.paymentMethod = constants.PaymentMethodCreditBook;

                                        this.state.paymentModified = true;
                                        this.props.sale.paidAmount = this.props.sale.paidAmount + this.state.displayAmount;
                                        this.state.paidAmount = this.state.paidAmount + this.state.displayAmount;
                                        this.state.payableAmount = this.state.payableAmount - this.state.displayAmount;
                                    
                                        this.state.displayAmount = 0.0;
                                        this.state.screenAmountNeedsToBeCleared = true;
                                        
                                        this.state.showCreditBookDialogue = false;
                                        this.setState({});

                                        if (this.state.payableAmount <= constants.numericThresholdValue)
                                        {
                                            await this.props.onPaymentCompletion();
                                            this.props.onClose(this.state.paymentModified);
                                        }

                                    }}/>
    }

}


export default PaymentDialogue;